import selectOption from '@/store/dict/selectOptionDict'

export default {
  data() {
    return {
      m_headData: [
        {
          name: 'receiveId',
          columnProps: {
            prop: 'receiveId',
            label: '应收ID',
            width: 100,
          },
        },
        {
          name: 'content',
          columnProps: {
            prop: 'content',
            label: '收款内容',
          },
          getText: ({ row }) => {
            if (this.freeTypeList.find((item) => item.code === row.content)) {
              return this.freeTypeList.find((item) => item.code === row.content).name
            }
          },
        },
        {
          name: 'customerType',
          columnProps: {
            prop: 'customerType',
            label: '付款方类型',
            width: 100,
          },
          getText: ({ row }) => selectOption.customerTypeDict[row.customerType],
        },
        {
          name: 'customer',
          columnProps: {
            prop: 'customer',
            label: '付款方',
            width: 160,
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'accruedCycle',
          columnProps: {
            prop: 'accruedCycle',
            label: '款项周期',
          },
        },
        {
          name: 'receivableDate',
          columnProps: {
            prop: 'receivableDate',
            label: '应收日期',
          },
        },
        {
          name: 'itemAmount',
          columnProps: {
            prop: 'itemAmount',
            label: '款项金额',
          },
        },
        {
          name: 'relieveAmount',
          columnProps: {
            prop: 'relieveAmount',
            label: '减免金额',
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            prop: 'receivableAmount',
            label: '应收金额',
          },
          getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
        },
        {
          name: 'receivingAmount',
          columnProps: {
            prop: 'receivingAmount',
            label: '收款中金额',
            width: 100,
          },
          getText: ({ row }) => this.numberWithCommas(row.receivingAmount),
        },
        {
          name: 'receivedAmount',
          columnProps: {
            prop: 'receivedAmount',
            label: '已收金额',
          },
          getText: ({ row }) => this.numberWithCommas(row.receivedAmount),
        },
        // {
        //   name: 'refundedAmount',
        //   columnProps: {
        //     prop: 'refundedAmount',
        //     label: '已退款金额',
        //     width: 100
        //   },
        //   getText: ({ row }) => this.numberWithCommas(row.refundedAmount)
        // },
      ],
    }
  },
}
